import { ERROR_MAP_LIST } from './error';

export const errorHandler = new function () {
  return {
    /**
     * 监管可能会error的问题
     */
    intercept: (fn: Function) => {
      try {
        fn()
      } catch (error) {
        window.$notification['error']({
          content: '错误提示',
          meta: '页面好像出了点问题，请刷新重试！',
          duration: 0,
        })
      }
    },
    getErrorCodeHandler: (error: string) => {
      if (error) {
        let targetError = ERROR_MAP_LIST.find((item) => error.includes(item.code))
        if (targetError) {
          window.$notification['error']({
            content: '错误提示',
            meta: targetError.msg,
            duration: 0,
          })
        }
      }
    },
    getErrorCode: (error: any) => {
      // 先判断 error 是否为字符串
      if (typeof error !== 'string') {
        // 如果不是字符串，可以返回 null 或 undefined，或者其他默认值
        return null;
      }
      // 如果是字符串，则进行查找
      return ERROR_MAP_LIST.find(
        (item) =>
          item &&
          typeof item.code === 'string' &&
          item.code.length > 0 &&
          error.includes(item.code)
      );
    }
  }
}